const namespace = {
  title: "Neighborhood Showcase",
  search: "Search",
  noData:
    "You haven't added any neighborhoods to your list yet. Head over to the <bold><LinkToHub>My Neighborhoods</LinkToHub></bold> section to select them.",
} as const;

export default namespace;
